// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-warning[data-v-95488b62] {\n  color: rgb(204 33 40);\n  font-size: 100px;\n}\n.tx-center[data-v-95488b62] {\n  text-align: center;\n}\n.line-text[data-v-95488b62] {\n  border: 1px solid #dfdfdf !important;\n  border-radius: 15px;\n}\n.pad-text[data-v-95488b62] {\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
